import { AscModalSharePropsI } from "./AscModalShare.type";
import AscModal from "../AscModal/AscModal";
import styles from "./AscModalShare.module.scss";
// import { CloseFilledRectangleIcon } from "../AscIcons";
import AscButtonShare from "../AscButtonShare/AscButtonShare";

function AscModalShare({
  visible,
  setVisible,
  title,
  description,
  link,
}: AscModalSharePropsI) {
  return (
    <AscModal
      visible={visible}
      setVisible={setVisible}
      modalClassName={styles.modalClassName}
      backdropClassName={styles.backdropClassName}
      withBackground={false}
    >
      <div className={styles.element}>
        <div className={styles.top}>
          <div className={styles.title}>{title}</div>
          {description && (
            <div className={styles.description}>{description}</div>
          )}
        </div>

        <div className={styles.buttonList}>
          <AscButtonShare type={"copy-link"} link={link} />
          <AscButtonShare type={"linkedin"} link={link} />
          <AscButtonShare type={"twitter"} link={link} />
          <AscButtonShare type={"facebook"} link={link} />
          <AscButtonShare type={"email"} link={link} />
        </div>
      </div>
    </AscModal>
  );
}

export default AscModalShare;
